import React from 'react';
import { connect } from 'react-redux';

// Components

import IdahoFooter from '../../components/common/footers/IdahoFooter';
import MinnesotaFooter from '../../components/common/footers/MinnesotaFooter';
import NevadaFooter from '../../components/common/footers/NevadaFooter';
import New_JerseyFooter from '../../components/common/footers/New_JerseyFooter';
import New_MexicoFooter from '../../components/common/footers/New_MexicoFooter';
import PennsylvaniaFooter from '../../components/common/footers/PennsylvaniaFooter';
import GeorgiaFooter from '../../components/common/footers/GeorgiaFooter';
import VirginiaFooter from '../../components/common/footers/VirginiaFooter';
import GetinsuredFooter from '../../components/common/footers/GetinsuredFooter';

// Constants

import { configs } from '../../constants/configs/configs';
import CaliforniaFooter from '../../components/common/footers/CaliforniaFooter';



const FooterContainer = props => {

    const {
        environment,
        environment: {
            stateCode
        }
    } = props;

    switch(true) {
        case stateCode === configs.states.CALIFORNIA:
            return <CaliforniaFooter {...{ environment }}/>;
        case stateCode === configs.states.IDAHO:
            return <IdahoFooter {...{ environment }}/>;

        case stateCode === configs.states.MINNESOTA:
            return <MinnesotaFooter {...{ environment }}/>;

        case stateCode === configs.states.NEVADA:
            return <NevadaFooter {...{ environment }}/>;

        case stateCode === configs.states.NEW_JERSEY:
            return <New_JerseyFooter {...{ environment }}/>;

        case stateCode === configs.states.NEW_MEXICO:
            return <New_MexicoFooter {...{ environment }}/>;

        case stateCode === configs.states.PENNSYLVANIA:
            return <PennsylvaniaFooter {...{ environment }}/>;

        case stateCode === configs.states.GEORGIA:
            return <GeorgiaFooter {...{ environment }}/>;

        case stateCode === configs.states.VIRGINIA:
            return <VirginiaFooter {...{ environment }}/>;

        case stateCode === configs.states.GETINSURED:
            return <GetinsuredFooter {...{ environment }}/>;

        default:
            return null;
    }
};

const mapStateToProps = state => ({
    environment: state.common.environment
});

export default connect(mapStateToProps)(FooterContainer);
